function updateWishlistIndicator(size)
{
    let $item = $('#wishlist-size');
    $item.text(size);

    size > 0
        ? $item.removeClass('d-none')
        : $item.addClass('d-none');
}

(function ($) {
    "use strict";

    /*
    ** Button to add/remove property from wishlist
     */
    $('.btn-wishlist').click(function (e) {
        let $this = $(this);
        $this.toggleClass('btn-selected');

        $.ajax({
            url: $this.data('action'),
            method: 'POST',
            data: {
                property_id: $this.data('property-id')
            }
        }).done(function (data) {
            updateWishlistIndicator(data.size);
        });
        e.preventDefault();
    });

    /*
    ** Add/remove property from the wishlist
     */
    $('.add-selection').click(function (e) {
        let $this = $(this);
        $this.toggleClass('selected');

        $.ajax({
            url: $this.data('action'),
            method: 'POST',
            data: {
                property_id: $this.data('property-id')
            }
        }).done(function (data) {
            updateWishlistIndicator(data.size);
            if ($this.is('.self-remove')) {
                $this.parents('.owl-item').remove();
            }
            if (data.size === 0) {
                $('.main').remove();
                $('.empty-wishlist').removeClass('d-none');
            }
            $('.wishlist-remove[data-property-id="' + $this.data('property-id') + '"]').parents('li').remove();
        });
        e.preventDefault();
    });

    /*
    ** Only remove property from the wishlist
     */
    $('.wishlist-remove').click(function (e) {
        let $this = $(this);
        $this.parents('li').hide('slow', function () {
            $this.parents('li').remove();
        });

        $.ajax({
            url: $this.data('action'),
            method: 'POST',
            data: {
                property_id: $this.data('property-id')
            }
        }).done(function (data) {
            updateWishlistIndicator(data.size);

            $('#property-carousel-' + $this.data('property-id')).parents('.owl-item').remove();

            if (data.size === 0) {
                $('.main').remove();
                $('.empty-wishlist').removeClass('d-none');
            }
        });
        e.preventDefault();
    });
})(window.$);
